import { Sortable, MultiDrag } from 'sortablejs';

Sortable.mount(new MultiDrag());

// Sortable
document.addEventListener('DOMContentLoaded', () => {
    const lists = document.querySelectorAll('.task-list');
    const selectedTasks = document.getElementById('selected-tasks');
    const selectedTasksCount = document.getElementById('selected-tasks-count');

    lists.forEach((list) => {
        const sortable = Sortable.create(list, {
            multiDrag: true, // Enable the plugin
            selectedClass: 'selected', // Class name for selected item
            // Key that must be down for items to be selected
            // multiDragKey: 'CTRL',
            avoidImplicitDeselect: false, // true - if you don't want to deselect items on outside click

            group: 'shared', // set both lists to same group
            handle: '.drag-cell', // handle's class
            filter: '.filtered', // 'filtered' class is not draggable
            animation: 150,
            onSort: function (evt) {
                const listArrayNew = Array.from(
                    document.getElementById('list').children
                )
                    .filter((item) => item.id.startsWith('task'))
                    .map((item) => parseInt(item.dataset.id));

                load(
                    'project/set_order/' + CURRENT_LIST,
                    'order=' + listArrayNew.join(',')
                );
            },
            onSelect: function (evt) {
                selectedTasksArr.push(evt.item);
                selectedTasksCount.innerHTML = selectedTasksArr.length;
                console.log(evt);
                console.log(selectedTasksArr);

                if (selectedTasksArr.length > 0) {
                    selectedTasks.classList.remove(
                        'pointer-events-none',
                        'opacity-0'
                    );
                }
            },
            onDeselect: function (evt) {
                selectedTasksArr.splice(selectedTasksArr.indexOf(evt.item), 1);
                selectedTasksCount.innerHTML = selectedTasksArr.length;
                console.log(evt);
                console.log(selectedTasksArr);

                if (selectedTasksArr.length === 0) {
                    selectedTasks.classList.add(
                        'pointer-events-none',
                        'opacity-0'
                    );
                }
            },
        });

        // console.log(sortable);
    });
});
